import { useCallback, useLayoutEffect, useRef } from "react"

// D3 retains constructor callbacks. Keep their identity stable while forwarding
// calls to the latest committed callback, including setters for a different atom.
export function useStableCallback<Args extends unknown[], Result>(callback: (...args: Args) => Result): (...args: Args) => Result {
    const callbackRef = useRef(callback)

    useLayoutEffect(() => {
        callbackRef.current = callback
    }, [callback])

    return useCallback((...args: Args) => callbackRef.current(...args), [])
}
